import { map } from 'lodash';
import { Location } from './location';
import { Permission } from './permission';

export class UserRole {
    roleId: number;
    roleDescription: string;
    isActive: boolean;
    roleName: string;
    userPermissions: Permission[];
    locations: Location[];

    constructor(data: any) {
        this.roleId = data?.roleId;
        this.roleDescription = data?.roleDescription;
        this.isActive = data?.isActive;
        this.roleName = data?.roleName;
        this.locations = data?.locations ? map(data.locations, (l: any) => new Location(l)) : undefined;
        this.userPermissions = data?.userPermissions ? map(data.userPermissions, (l: any) => new Permission(l)) : undefined;
    }

}